/* Mezkla logo overlap detector.

   Watches the header logo against a curated list of "trigger" text elements
   (headings, footer copy, on-image labels). On every scroll tick, if any
   trigger's bounding box intersects the logo's bounding box, the logo
   gets `.mezkla-header__logo--blank` which fades it to opacity 0.

   Single shared scroll listener — piggybacks on the `mezkla:scroll`
   CustomEvent dispatched by `header-scroll.js`, so no extra scroll handlers.

   Triggers are queried once at load and re-queried on resize / window load,
   not on every scroll, so the cost per tick is one rect-read per trigger
   plus one quick viewport-bounds check (off-screen triggers short-circuit).
*/
(function () {
  'use strict';

  var logo = document.querySelector('.mezkla-header__logo');
  if (!logo) return;

  /* Selectors for "things the logo shouldn't sit on top of".
     Kept tight on purpose — small uniform text (product card titles, filter
     chips, body paragraphs) is skipped so the logo doesn't flicker
     constantly while scrolling a grid. */
  var TRIGGER_SELECTOR = [
    /* Landing */
    '.categories-section__heading',
    '.categories-section__label',
    '.categories-section__view-all',
    /* /collections list page */
    '.collections-page__heading',
    '.collections-page__feature-header',
    '.collections-page__copy-body',
    '.collections-page__copy-link',
    /* PDP — gallery images + the full info copy column. Together these
       catch every "thing the logo would otherwise sit on top of" on the
       product page (mobile stacks gallery → info, desktop puts them
       side-by-side; either way one of these two selectors is under the
       logo at any given scroll position). */
    '.product-page__gallery img',
    '.product-page__info',
    '.related-products__heading',
    '.related-products .product-card',
    /* Cart page */
    '.cart-section__title',
    '.cart-section__line-title',
    /* Search / 404 / page templates — generic */
    'main > section h1',
    'main > section h2',
    /* Footer (every page) */
    '.mezkla-footer__brand',
    '.mezkla-footer__nav',
    '.mezkla-footer__meta'
  ].join(', ');

  var triggers = [];

  function refresh() {
    triggers = Array.prototype.slice.call(document.querySelectorAll(TRIGGER_SELECTOR));
  }

  function check() {
    var lr = logo.getBoundingClientRect();
    if (lr.height === 0) return;
    var vh = window.innerHeight;
    var overlap = false;
    for (var i = 0; i < triggers.length; i++) {
      var er = triggers[i].getBoundingClientRect();
      /* Off-viewport short-circuit — most triggers will be off-screen most
         of the time, so this is the hot path. */
      if (er.bottom < 0 || er.top > vh || er.height === 0) continue;
      /* Bounding-box intersection (vertical + horizontal). The logo is
         center-positioned, triggers usually span the gutter, so most
         in-viewport triggers WILL intersect horizontally — but we check
         anyway for the side-floating cases (chips, pill, etc.). */
      if (er.bottom > lr.top && er.top < lr.bottom &&
          er.right  > lr.left && er.left < lr.right) {
        overlap = true;
        break;
      }
    }
    logo.classList.toggle('mezkla-header__logo--blank', overlap);
  }

  refresh();
  /* Initial check after first paint so the logo state is correct on load
     (e.g., short pages where the footer is already in view). */
  if (window.requestAnimationFrame) {
    requestAnimationFrame(check);
  } else {
    setTimeout(check, 0);
  }

  document.addEventListener('mezkla:scroll', check);
  window.addEventListener('resize', function () { refresh(); check(); });
  window.addEventListener('load',   function () { refresh(); check(); });
})();
